import { Carousel, Slide } from "vue-carousel";
import ProjectionCard from "../ProjectionCard/ProjectionCard";

export default {
  components: {
    Carousel,
    Slide,
    ProjectionCard
  },
  props: ["projectionCards"],
  data() {
    return {
      //Default cards to be displayed
      perPageCount: 4,
      apiFilterParams: {}
    };
  },
  created() {
    let context = this;
    //Getting the apiconstents
    this.$router.app.$on("UpdateProjectionCards", data => {
   
      context.apiFilterParams = data;
    });
  },
  mounted() {
    window.addEventListener("resize", this.PerPageCountCarousel);
    this.PerPageCountCarousel();
  },
  methods: {
    //To set number of cards to display in different devices
    PerPageCountCarousel() {
      if (window.innerWidth < 600) {
        this.perPageCount = 1;
      } else if (window.innerWidth > 600 && window.innerWidth < 960) {
        this.perPageCount = 2;
      } else if (window.innerWidth > 960 && window.innerWidth < 1264) {
        this.perPageCount = 3;
      } else if (window.innerWidth > 1264 && window.innerWidth < 1904) {
        this.perPageCount = 4;
      } else {
        this.perPageCount = 4;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.PerPageCountCarousel);
  }
};
